// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"5":"components-tooltip","8":"components-slide-toggle","415":"components-modal","533":"components-page-header","889":"components-tablist"}[chunkId] || chunkId) + ".css";
};